/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumAppointmentTypeDependentsRulesFacilityMatchCriteria = "id" | "postcode" | "%future added value";
export type EnumAppointmentTypeExternalIdSource = "acomrapidpm" | "acuityscheduling" | "adspm" | "advancedmd" | "allmeds" | "allscriptspm" | "allscriptsunity" | "amazingcharts" | "athenahealth" | "athenamdp" | "avimark" | "brightree" | "carecloud" | "caretracker" | "centricityps" | "cerner" | "clearpractice" | "clinicient" | "clinix" | "clinux" | "compulink" | "curemd" | "dentrix" | "drchrono" | "dsnpm" | "duxware" | "eclinicalmobile" | "eclinicalworks10E" | "eclinicalworkssql" | "emapm" | "emds" | "epic" | "epicconfirmationpickup" | "ezderm" | "ezemrx" | "fullslate" | "gcalendar" | "genericfhir" | "ggastromobile" | "gmed" | "greenwayintergy" | "greenwayprimesuite" | "healthnautica" | "hl7" | "hl7Pickup" | "imedicware" | "imsgo" | "isalus" | "kareo" | "keymedical" | "labretriever" | "lumacare" | "lumamock" | "lytec" | "managementplus" | "mdoffice" | "medevolve" | "medicalmaster" | "medicalmastermind" | "medinformatix" | "meditechexpanse" | "meditouch" | "medstreaming" | "mi7" | "micromd" | "mindbody" | "modmedfhir" | "mwtherapy" | "nextech" | "nextechfhir" | "nextechpracticeplus" | "nextgen" | "nuemd" | "officeally" | "oncoemrfilepickup" | "onetouch" | "openemr" | "optimispt" | "phoenixortho" | "practicefusion" | "practiceperfect" | "raintree" | "recall" | "referral" | "revflow" | "roche" | "somnoware" | "successehs" | "systemedx" | "theraoffice" | "valant" | "webedoctor" | "webpt" | "%future added value";
export type EnumAppointmentTypeModality = "officeVisit" | "telehealth" | "%future added value";
export type FilterFindManyAppointmentTypeInput = {
    user?: string | null | undefined;
    name?: string | null | undefined;
    alternativeName?: string | null | undefined;
    description?: string | null | undefined;
    duration?: number | null | undefined;
    externalId?: AppointmentTypeExternalIdInput | null | undefined;
    visible?: boolean | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    deleted?: number | null | undefined;
    setting?: string | null | undefined;
    settings?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    dependents?: Array<AppointmentTypeDependentsInput | null> | null | undefined;
    modality?: EnumAppointmentTypeModality | null | undefined;
    specialInstructions?: string | null | undefined;
    daysAheadsToVerifyInsurance?: number | null | undefined;
    _id?: string | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    OR?: Array<FilterFindManyAppointmentTypeInput> | null | undefined;
    AND?: Array<FilterFindManyAppointmentTypeInput> | null | undefined;
};
export type AppointmentTypeExternalIdInput = {
    source?: EnumAppointmentTypeExternalIdSource | null | undefined;
    value?: string | null | undefined;
    _id?: string | null | undefined;
};
export type AppointmentTypeDependentsInput = {
    appointmentType?: string | null | undefined;
    rules?: AppointmentTypeDependentsRulesInput | null | undefined;
    _id?: string | null | undefined;
};
export type AppointmentTypeDependentsRulesInput = {
    findAvailabilityAfter?: AppointmentTypeDependentsRulesFindAvailabilityAfterInput | null | undefined;
    facilityMatch?: AppointmentTypeDependentsRulesFacilityMatchInput | null | undefined;
    _id?: string | null | undefined;
};
export type AppointmentTypeDependentsRulesFindAvailabilityAfterInput = {
    enabled?: boolean | null | undefined;
    maxMinutes?: number | null | undefined;
    minMinutes?: number | null | undefined;
    _id?: string | null | undefined;
};
export type AppointmentTypeDependentsRulesFacilityMatchInput = {
    criteria?: EnumAppointmentTypeDependentsRulesFacilityMatchCriteria | null | undefined;
    _id?: string | null | undefined;
};
export type OperatorsFilterFindManyAppointmentTypeInput = {
    user?: UserOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    name?: NameOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    alternativeName?: AlternativeNameOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    description?: DescriptionOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    duration?: DurationOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    externalId?: ExternalIdOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    visible?: VisibleOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    setting?: SettingOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    settings?: SettingsOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    externalRawSource?: ExternalRawSourceOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    dependents?: DependentsOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    modality?: ModalityOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    specialInstructions?: SpecialInstructionsOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    daysAheadsToVerifyInsurance?: DaysAheadsToVerifyInsuranceOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
    _id?: _idOperatorsFilterFindManyAppointmentTypeInput | null | undefined;
};
export type UserOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type NameOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AlternativeNameOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DescriptionOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DurationOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type ExternalIdOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: AppointmentTypeExternalIdInput | null | undefined;
    gte?: AppointmentTypeExternalIdInput | null | undefined;
    lt?: AppointmentTypeExternalIdInput | null | undefined;
    lte?: AppointmentTypeExternalIdInput | null | undefined;
    ne?: AppointmentTypeExternalIdInput | null | undefined;
    in?: Array<AppointmentTypeExternalIdInput | null> | null | undefined;
    nin?: Array<AppointmentTypeExternalIdInput | null> | null | undefined;
    regex?: AppointmentTypeExternalIdInput | null | undefined;
};
export type VisibleOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DeletedOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type SettingOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SettingsOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ExternalRawSourceOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type DependentsOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: AppointmentTypeDependentsInput | null | undefined;
    gte?: AppointmentTypeDependentsInput | null | undefined;
    lt?: AppointmentTypeDependentsInput | null | undefined;
    lte?: AppointmentTypeDependentsInput | null | undefined;
    ne?: AppointmentTypeDependentsInput | null | undefined;
    in?: Array<AppointmentTypeDependentsInput | null> | null | undefined;
    nin?: Array<AppointmentTypeDependentsInput | null> | null | undefined;
    regex?: AppointmentTypeDependentsInput | null | undefined;
};
export type ModalityOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: EnumAppointmentTypeModality | null | undefined;
    gte?: EnumAppointmentTypeModality | null | undefined;
    lt?: EnumAppointmentTypeModality | null | undefined;
    lte?: EnumAppointmentTypeModality | null | undefined;
    ne?: EnumAppointmentTypeModality | null | undefined;
    in?: Array<EnumAppointmentTypeModality | null> | null | undefined;
    nin?: Array<EnumAppointmentTypeModality | null> | null | undefined;
    regex?: EnumAppointmentTypeModality | null | undefined;
};
export type SpecialInstructionsOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DaysAheadsToVerifyInsuranceOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type _idOperatorsFilterFindManyAppointmentTypeInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FilterAppointmentTypeList_refetchableVariables = {
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    filter?: FilterFindManyAppointmentTypeInput | null | undefined;
};
export type FilterAppointmentTypeList_refetchableResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterAppointmentTypeList_Query">;
};
export type FilterAppointmentTypeList_refetchable = {
    readonly response: FilterAppointmentTypeList_refetchableResponse;
    readonly variables: FilterAppointmentTypeList_refetchableVariables;
};



/*
query FilterAppointmentTypeList_refetchable(
  $count: Int = 25
  $cursor: String
  $filter: FilterFindManyAppointmentTypeInput
) {
  ...FilterAppointmentTypeList_Query_1G22uz
}

fragment FilterAppointmentTypeList_Query_1G22uz on Query {
  appointmentTypeConnection(first: $count, after: $cursor, filter: $filter, sort: NAME_ASC) {
    edges {
      node {
        _id
        name
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "NAME_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterAppointmentTypeList_refetchable",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "FilterAppointmentTypeList_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterAppointmentTypeList_refetchable",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AppointmentTypeConnection",
        "kind": "LinkedField",
        "name": "appointmentTypeConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AppointmentTypeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AppointmentType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterAppointmentTypeList_appointmentTypeConnection",
        "kind": "LinkedHandle",
        "name": "appointmentTypeConnection"
      }
    ]
  },
  "params": {
    "cacheID": "34a255e29e2f79d2b9d48a425040cae6",
    "id": null,
    "metadata": {},
    "name": "FilterAppointmentTypeList_refetchable",
    "operationKind": "query",
    "text": "query FilterAppointmentTypeList_refetchable(\n  $count: Int = 25\n  $cursor: String\n  $filter: FilterFindManyAppointmentTypeInput\n) {\n  ...FilterAppointmentTypeList_Query_1G22uz\n}\n\nfragment FilterAppointmentTypeList_Query_1G22uz on Query {\n  appointmentTypeConnection(first: $count, after: $cursor, filter: $filter, sort: NAME_ASC) {\n    edges {\n      node {\n        _id\n        name\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '2545fc220fb8f2fc157a6f977970fe5b';
export default node;
